import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DetailsHeader from "../Customer/components/DetailsHeader";
import { protectedAxiosInstance } from "../../api/axiosManagement";
import Documents from "./components/companydetils/Documents";
import OrderDetails from "./components/companydetils/OrderDetails";
import ProjectDetails from "./components/companydetils/ProjectDetails";
import Address from "./components/companydetils/Address";
import Timeline from "./components/companydetils/Timeline";
import DetailSection from "./components/companydetils/DetailSection";
import BusinessSection from "./components/companydetils/BusinessSection";
import BankSection from "./components/companydetils/BankSection";
import CouponsSection from "./components/companydetils/CouponsSection";
import CustomersSection from "./components/companydetils/CustomersSection";
import Notfound from "../404/components/Notfound";
import { getProfessionalStatusHistory } from "../../api/customers";

const CompanyDetail = () => {
  const { id: customerID } = useParams();
  const [pageLoading, setPageLoading] = useState(false);
  const [details, setDetails] = useState<any>();
  const [notFound, setNotFound] = useState(false);
  const [professionalStatusHistory, setProfessionalStatusHistory] =
    useState<any>([]);
  const [loading, setLoading] = useState(false);

  const [projectsData, setProjectsData] = useState<any>([]);

  const fetchProjects = () => {
    return protectedAxiosInstance
      .get(`/admin/projects?professional_id=${details?.p_individual?.id}`)
      .then((res) => res.data.data)
      .catch((err) => {
        console.error(err, "Error in getting professional details");
        throw err;
      });
  };

  useEffect(() => {
    if (details?.p_individual?.id) {
      fetchProjects().then((res) => {
        setProjectsData(res);
      });
    }
  }, [details?.p_individual?.id]);

  const fetchDetails = () => {
    return protectedAxiosInstance
      .get(`/admin/accounts/professional/${customerID}`)
      .then((res) => res.data.data)
      .catch((err) => {
        throw err;
      });
  };

  useEffect(() => {
    setPageLoading(true);

    Promise.all([fetchDetails()])
      .then(([details]) => {
        setDetails(details);
        if (!details?.customer?.is_professional) {
          setNotFound(true);
        }
      })
      .catch((err) => {
        if (err.status === 404) {
          setNotFound(true);
        }
      })
      .finally(() => {
        setPageLoading(false);
      });
  }, [customerID]);

  useEffect(() => {
    setLoading(true);
    getProfessionalStatusHistory(customerID)
      .then((res) => {
        const ordersStats = res?.data;
        setProfessionalStatusHistory(ordersStats);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  if (notFound) {
    return <Notfound />;
  }

  return (
    <>
      {/* Navigation */}
      <DetailsHeader data={details} />
      <div
        className={`flex flex-row relative ${
          pageLoading ? "animate-pulse" : ""
        }`}
      >
        {/* First Column  */}
        <div className="w-[75%] border-r-2 px-5 py-6">
          {/* <div className="flex flex-row justify-between items-start ">
            <div className="flex flex-row gap-4">
              <div className=" w-[150px] h-16 flex flex-col items-start pl-4 justify-center border-l-2 border-l-pot-yellow bg-[#F9FAFB]">
                <p className="font-medium text-[14px]">25,00,000</p>
                <p className="text-[12px] text-[#AEAEAE]">Total spend</p>
              </div>
              <div className=" w-[150px] h-16 flex flex-col items-start pl-4 justify-center border-l-2 border-l-pot-yellow bg-[#F9FAFB]">
                <p className="font-medium text-[14px]">25</p>
                <p className="text-[12px] text-[#AEAEAE]">Total orders</p>
              </div>
              <div className=" w-[150px] h-16 flex flex-col items-start pl-4 justify-center border-l-2 border-l-pot-yellow bg-[#F9FAFB]">
                <p className="font-medium text-[14px]">100,000</p>
                <p className="text-[12px] text-[#AEAEAE]">
                  Average order value
                </p>
              </div>
            </div>
          </div> */}

          {/* <Documents /> */}

          {/* <OrderDetails /> */}

          {/* Project Details */}
          <ProjectDetails projectsData={projectsData?.project} />

          {/* Address */}
          {/* <Address /> */}

          {/* Timeline */}
          <Timeline professionalStatusHistory={professionalStatusHistory} />
        </div>

        {/* Second Column */}
        <div className="max-h-full sticky top-10 overflow-y-auto w-[25%] border-r-2">
          <DetailSection data={details} loading={pageLoading} />
          <BusinessSection data={details} loading={pageLoading} />
          <BankSection data={details} loading={pageLoading} />
          {/* <CouponsSection />
          <CustomersSection /> */}
        </div>
      </div>
    </>
  );
};

export default CompanyDetail;
